<template>
  <el-dialog
    title="成本价设置"
    :visible.sync="visible"
    label-width="100px"
    width="40%"
    @close="$emit('update:show', false)"
  >
    <el-form size="small" :model="model" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="产品名称">
        <el-input v-model="model.name" autocomplete="off" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="成本价" prop="price">
        <el-input-number v-model="model.cost_price.price" :precision="2" :min="0"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateItem } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    }
  },
  data() {
    return {
      visible: this.show,
      rules: {}
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          let res = await updateItem(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>